<swal
    #alertTemplate
    [customClass]="{ popup: 'custom-swal-popup-cancel' }"
    [showCloseButton]="true"
>
    <ng-container *swalPortal="swalTargets.actions">
        <div class="container-btns d-flex">
            <fe-button
                *ngIf="options.showConfirm"
                class="mb-6 me-3"
                [ngClass]="{ 'me-3': options.showCancel }"
                [style]="'tertiary'"
                (onClick)="onClickConfirm()"
                [btnClass]="'btn-alert-confirm'"
                >{{ options.confirmText }}</fe-button
            >
            <fe-button
                *ngIf="options.showCancel"
                class="mb-6"
                [style]="'sixth'"
                [btnClass]="'btn-alert-cancel'"
                (onClick)="onClickCancel()"
                >{{ options.cancelText }}</fe-button
            >
        </div>
    </ng-container>
    <div *swalPortal="undefined">
        <div class="cancel container-fluid">
            <span [innerHTML]="options.title" class="cancel__title"></span>
            <span
                [innerHTML]="options.subtitle"
                class="cancel__subtitle"
            ></span>
        </div>
    </div>
</swal>
